// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Numeral from "numeral";
import * as Belt_Map from "rescript/lib/es6/belt_Map.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Tabs from "@reach/tabs";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Db$Coronate from "../Db.res.js";
import * as ReactFeather from "react-feather";
import * as Hooks$Coronate from "../Hooks.res.js";
import * as Pages$Coronate from "../Pages.res.js";
import * as Utils$Coronate from "../Utils.res.js";
import * as Data_Id$Coronate from "../Data/Data_Id.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Externals$Coronate from "../Externals/Externals.res.js";
import * as Data_Match$Coronate from "../Data/Data_Match.res.js";
import * as PairPicker$Coronate from "./PairPicker.res.js";
import * as Data_Config$Coronate from "../Data/Data_Config.res.js";
import * as Data_Player$Coronate from "../Data/Data_Player.res.js";
import * as Data_Rounds$Coronate from "../Data/Data_Rounds.res.js";
import * as Data_Ratings$Coronate from "../Data/Data_Ratings.res.js";
import * as Data_Scoring$Coronate from "../Data/Data_Scoring.res.js";
import VisuallyHidden from "@reach/visually-hidden";
import * as TournamentUtils$Coronate from "./TournamentUtils.res.js";

function PageRound$PlayerMatchInfo(props) {
  var match = TournamentUtils$Coronate.getScoreInfo(props.player, props.scoreData, props.config, props.getPlayer, props.players, props.origRating, props.newRating);
  var player = match.player;
  return JsxRuntime.jsxs("dl", {
              children: [
                JsxRuntime.jsx("h3", {
                      children: Data_Player$Coronate.fullName(player)
                    }),
                JsxRuntime.jsx("dt", {
                      children: "Score"
                    }),
                JsxRuntime.jsx("dd", {
                      children: match.score
                    }),
                JsxRuntime.jsx("dt", {
                      children: "Rating"
                    }),
                JsxRuntime.jsx(Utils$Coronate.TestId.make, {
                      children: JsxRuntime.jsx("dd", {
                            children: match.rating,
                            "aria-label": "Rating for " + Data_Player$Coronate.fullName(player)
                          }),
                      testId: "rating-" + Data_Id$Coronate.toString(player.id)
                    }),
                JsxRuntime.jsx("dt", {
                      children: "Color balance"
                    }),
                JsxRuntime.jsx("dd", {
                      children: match.colorBalance
                    }),
                JsxRuntime.jsx("dt", {
                      children: "Has had a bye round"
                    }),
                JsxRuntime.jsx("dd", {
                      children: match.hasBye ? "Yes" : "No"
                    }),
                JsxRuntime.jsx("dt", {
                      children: "Opponent history"
                    }),
                JsxRuntime.jsx("dd", {
                      children: JsxRuntime.jsx("ol", {
                            children: match.opponentResults
                          })
                    }),
                JsxRuntime.jsx("dt", {
                      children: "Players to avoid:"
                    }),
                JsxRuntime.jsx("dd", {
                      children: JsxRuntime.jsx("ul", {
                            children: match.avoidListHtml
                          })
                    })
              ],
              className: "player-card"
            });
}

function PageRound$MatchRow(props) {
  var config = props.config;
  var __className = props.className;
  var tournament = props.tournament;
  var scoreData = props.scoreData;
  var setSelectedMatch = props.setSelectedMatch;
  var selectedMatch = props.selectedMatch;
  var roundId = props.roundId;
  var m = props.m;
  var pos = props.pos;
  var __isCompact = props.isCompact;
  var isCompact = __isCompact !== undefined ? __isCompact : false;
  var className = __className !== undefined ? __className : "";
  var tourney = tournament.tourney;
  var roundList = tourney.roundList;
  var setTourney = tournament.setTourney;
  var playersDispatch = tournament.playersDispatch;
  var players = tournament.players;
  var getPlayer = tournament.getPlayer;
  var dialog = Hooks$Coronate.useBool(false);
  var whitePlayer = getPlayer(m.whiteId);
  var blackPlayer = getPlayer(m.blackId);
  var resultDisplay = function (playerColor) {
    var won = JsxRuntime.jsx(ReactFeather.Award, {
          className: "pageround__wonicon"
        });
    var lost = JsxRuntime.jsx(VisuallyHidden, {
          children: "Lost"
        });
    var aborted = JsxRuntime.jsx("span", {
          children: "❌",
          "aria-label": "Draw",
          role: "img",
          style: {
            filter: "grayscale(60%)"
          }
        });
    var match = m.result;
    switch (match) {
      case "WhiteWon" :
          if (playerColor === "White") {
            return won;
          } else {
            return lost;
          }
      case "BlackWon" :
          if (playerColor === "White") {
            return lost;
          } else {
            return won;
          }
      case "Draw" :
          return JsxRuntime.jsx("span", {
                      children: "🤝",
                      "aria-label": "Draw",
                      role: "img",
                      style: {
                        filter: "grayscale(70%)"
                      }
                    });
      case "Aborted" :
          return aborted;
      case "WhiteAborted" :
          if (playerColor === "White") {
            return aborted;
          } else {
            return won;
          }
      case "BlackAborted" :
          if (playerColor === "White") {
            return won;
          } else {
            return aborted;
          }
      case "NotSet" :
          return JsxRuntime.jsx(VisuallyHidden, {
                      children: "Not set"
                    });
      
    }
  };
  var setMatchResult = function (jsResultCode) {
    var newResult = Data_Match$Coronate.Result.fromString(jsResultCode);
    if (m.result === newResult) {
      return ;
    }
    var blackId = m.blackId;
    var whiteId = m.whiteId;
    var whiteOpt = Belt_Map.get(players, whiteId);
    var blackOpt = Belt_Map.get(players, blackId);
    var match;
    var exit = 0;
    if (whiteOpt !== undefined && blackOpt !== undefined) {
      switch (newResult) {
        case "WhiteWon" :
        case "BlackWon" :
        case "Draw" :
            exit = 1;
            break;
        default:
          exit = 2;
      }
    } else {
      exit = 2;
    }
    switch (exit) {
      case 1 :
          match = Data_Ratings$Coronate.calcNewRatings(m.whiteOrigRating, m.blackOrigRating, whiteOpt.matchCount, blackOpt.matchCount, newResult);
          break;
      case 2 :
          match = [
            m.whiteOrigRating,
            m.blackOrigRating
          ];
          break;
      
    }
    var blackNewRating = match[1];
    var whiteNewRating = match[0];
    var whiteOpt$1 = Belt_Option.map(whiteOpt, (function (white) {
            return Data_Player$Coronate.setRating(white, whiteNewRating);
          }));
    var blackOpt$1 = Belt_Option.map(blackOpt, (function (black) {
            return Data_Player$Coronate.setRating(black, blackNewRating);
          }));
    if (!Data_Match$Coronate.isBye(m)) {
      var match$1 = m.result;
      if (match$1 === "NotSet") {
        Belt_Option.forEach(whiteOpt$1, (function (white) {
                playersDispatch({
                      TAG: "Set",
                      _0: whiteId,
                      _1: Data_Player$Coronate.succMatchCount(white)
                    });
              }));
        Belt_Option.forEach(blackOpt$1, (function (black) {
                playersDispatch({
                      TAG: "Set",
                      _0: blackId,
                      _1: Data_Player$Coronate.succMatchCount(black)
                    });
              }));
      } else if (newResult === "NotSet") {
        Belt_Option.forEach(whiteOpt$1, (function (white) {
                playersDispatch({
                      TAG: "Set",
                      _0: whiteId,
                      _1: Data_Player$Coronate.predMatchCount(white)
                    });
              }));
        Belt_Option.forEach(blackOpt$1, (function (black) {
                playersDispatch({
                      TAG: "Set",
                      _0: blackId,
                      _1: Data_Player$Coronate.predMatchCount(black)
                    });
              }));
      } else {
        Belt_Option.forEach(whiteOpt$1, (function (white) {
                playersDispatch({
                      TAG: "Set",
                      _0: whiteId,
                      _1: white
                    });
              }));
        Belt_Option.forEach(blackOpt$1, (function (black) {
                playersDispatch({
                      TAG: "Set",
                      _0: blackId,
                      _1: black
                    });
              }));
      }
    }
    var newMatch_id = m.id;
    var newMatch_whiteId = m.whiteId;
    var newMatch_blackId = m.blackId;
    var newMatch_whiteOrigRating = m.whiteOrigRating;
    var newMatch_blackOrigRating = m.blackOrigRating;
    var newMatch = {
      id: newMatch_id,
      whiteId: newMatch_whiteId,
      blackId: newMatch_blackId,
      whiteNewRating: whiteNewRating,
      blackNewRating: blackNewRating,
      whiteOrigRating: newMatch_whiteOrigRating,
      blackOrigRating: newMatch_blackOrigRating,
      result: newResult
    };
    Belt_Option.map(Data_Rounds$Coronate.setMatch(roundList, roundId, newMatch), (function (roundList) {
            setTourney({
                  id: tourney.id,
                  name: tourney.name,
                  date: tourney.date,
                  playerIds: tourney.playerIds,
                  scoreAdjustments: tourney.scoreAdjustments,
                  byeQueue: tourney.byeQueue,
                  tieBreaks: tourney.tieBreaks,
                  roundList: roundList
                });
          }));
  };
  var setMatchResultBlur = function ($$event) {
    setMatchResult($$event.target.value);
  };
  var setMatchResultChange = function ($$event) {
    setMatchResult($$event.target.value);
  };
  var selected = selectedMatch !== undefined ? Data_Id$Coronate.eq(m.id, Caml_option.valFromOption(selectedMatch)) : false;
  var tmp;
  if (isCompact || setSelectedMatch === undefined) {
    tmp = null;
  } else {
    var tmp$1;
    if (scoreData !== undefined) {
      var scoreData$1 = Caml_option.valFromOption(scoreData);
      tmp$1 = JsxRuntime.jsxs(Externals$Coronate.Dialog.make, {
            isOpen: dialog.state,
            onDismiss: (function () {
                dialog.setFalse();
              }),
            ariaLabel: "Match information",
            children: [
              JsxRuntime.jsx("button", {
                    children: "close",
                    className: "button-micro button-primary",
                    onClick: (function (param) {
                        dialog.setFalse();
                      })
                  }),
              JsxRuntime.jsx("p", {
                    children: tourney.name
                  }),
              JsxRuntime.jsx("p", {
                    children: "Round " + String(roundId + 1 | 0) + " match " + String(pos + 1 | 0)
                  }),
              JsxRuntime.jsxs(Utils$Coronate.PanelContainer.make, {
                    children: [
                      JsxRuntime.jsx(Utils$Coronate.Panel.make, {
                            children: JsxRuntime.jsx(PageRound$PlayerMatchInfo, {
                                  player: whitePlayer,
                                  origRating: m.whiteOrigRating,
                                  newRating: m.whiteNewRating,
                                  getPlayer: getPlayer,
                                  scoreData: scoreData$1,
                                  players: players,
                                  config: config
                                })
                          }),
                      JsxRuntime.jsx(Utils$Coronate.Panel.make, {
                            children: JsxRuntime.jsx(PageRound$PlayerMatchInfo, {
                                  player: blackPlayer,
                                  origRating: m.blackOrigRating,
                                  newRating: m.blackNewRating,
                                  getPlayer: getPlayer,
                                  scoreData: scoreData$1,
                                  players: players,
                                  config: config
                                })
                          })
                    ]
                  })
            ],
            className: ""
          });
    } else {
      tmp$1 = null;
    }
    tmp = JsxRuntime.jsxs("td", {
          children: [
            Belt_Option.mapWithDefault(selectedMatch, true, (function (id) {
                    return !Data_Id$Coronate.eq(id, m.id);
                  })) ? JsxRuntime.jsxs("button", {
                    children: [
                      JsxRuntime.jsx(ReactFeather.Circle, {}),
                      JsxRuntime.jsx(VisuallyHidden, {
                            children: "Edit match for " + Data_Player$Coronate.fullName(whitePlayer) + " versus " + Data_Player$Coronate.fullName(blackPlayer)
                          })
                    ],
                    className: "button-ghost",
                    title: "Edit match",
                    onClick: (function (param) {
                        setSelectedMatch(function (param) {
                              return Caml_option.some(m.id);
                            });
                      })
                  }) : JsxRuntime.jsx("button", {
                    children: JsxRuntime.jsx(ReactFeather.CheckCircle, {}),
                    className: "button-ghost button-pressed",
                    title: "End editing match",
                    onClick: (function (param) {
                        setSelectedMatch(function (param) {
                              
                            });
                      })
                  }),
            JsxRuntime.jsxs("button", {
                  children: [
                    JsxRuntime.jsx(ReactFeather.Info, {}),
                    JsxRuntime.jsx(VisuallyHidden, {
                          children: "View information for match: " + Data_Player$Coronate.fullName(whitePlayer) + " versus " + Data_Player$Coronate.fullName(blackPlayer)
                        })
                  ],
                  className: "button-ghost",
                  title: "Open match information.",
                  onClick: (function (param) {
                      dialog.setTrue();
                    })
                }),
            tmp$1
          ],
          className: "pageround__controls data__input"
        });
  }
  return JsxRuntime.jsxs("tr", {
              children: [
                JsxRuntime.jsx("th", {
                      children: String(pos + 1 | 0),
                      className: "pageround__row-id table__number",
                      scope: "row"
                    }),
                JsxRuntime.jsx("td", {
                      children: resultDisplay("White"),
                      className: "pageround__playerresult"
                    }),
                JsxRuntime.jsx(Utils$Coronate.TestId.make, {
                      children: JsxRuntime.jsx("td", {
                            children: Data_Player$Coronate.fullName(whitePlayer),
                            className: "table__player row__player " + Data_Player$Coronate.Type.toString(whitePlayer.type_),
                            id: "match-" + (String(pos) + "-white")
                          }),
                      testId: "match-" + (String(pos) + "-white")
                    }),
                JsxRuntime.jsx("td", {
                      children: resultDisplay("Black"),
                      className: "pageround__playerresult"
                    }),
                JsxRuntime.jsx(Utils$Coronate.TestId.make, {
                      children: JsxRuntime.jsx("td", {
                            children: Data_Player$Coronate.fullName(blackPlayer),
                            className: "table__player row__player " + Data_Player$Coronate.Type.toString(blackPlayer.type_),
                            id: "match-" + (String(pos) + "-black")
                          }),
                      testId: "match-" + (String(pos) + "-black")
                    }),
                JsxRuntime.jsxs("td", {
                      children: [
                        Numeral(Data_Scoring$Coronate.Score.toFloat(Data_Scoring$Coronate.Score.fromResultWhite(m.result))).format("1/2"),
                        "-",
                        Numeral(Data_Scoring$Coronate.Score.toFloat(Data_Scoring$Coronate.Score.fromResultBlack(m.result))).format("1/2")
                      ],
                      className: "pageround__matchresult__score monospace"
                    }),
                JsxRuntime.jsx("td", {
                      children: JsxRuntime.jsx(Utils$Coronate.TestId.make, {
                            children: JsxRuntime.jsxs("select", {
                                  children: [
                                    JsxRuntime.jsx("option", {
                                          children: "Select winner",
                                          value: Data_Match$Coronate.Result.toString("NotSet")
                                        }),
                                    JsxRuntime.jsxs("option", {
                                          children: [
                                            Data_Config$Coronate.aliasToStringWhite(config),
                                            " won"
                                          ],
                                          value: Data_Match$Coronate.Result.toString("WhiteWon")
                                        }),
                                    JsxRuntime.jsxs("option", {
                                          children: [
                                            Data_Config$Coronate.aliasToStringBlack(config),
                                            " won"
                                          ],
                                          value: Data_Match$Coronate.Result.toString("BlackWon")
                                        }),
                                    JsxRuntime.jsx("option", {
                                          children: "Draw",
                                          value: Data_Match$Coronate.Result.toString("Draw")
                                        }),
                                    JsxRuntime.jsx("option", {
                                          children: "Aborted",
                                          value: Data_Match$Coronate.Result.toString("Aborted")
                                        }),
                                    JsxRuntime.jsxs("option", {
                                          children: [
                                            Data_Config$Coronate.aliasToStringWhite(config),
                                            " Aborted"
                                          ],
                                          value: Data_Match$Coronate.Result.toString("WhiteAborted")
                                        }),
                                    JsxRuntime.jsxs("option", {
                                          children: [
                                            Data_Config$Coronate.aliasToStringBlack(config),
                                            " Aborted"
                                          ],
                                          value: Data_Match$Coronate.Result.toString("BlackAborted")
                                        })
                                  ],
                                  className: "pageround__winnerSelect",
                                  value: Data_Match$Coronate.Result.toString(m.result),
                                  onBlur: setMatchResultBlur,
                                  onChange: setMatchResultChange
                                }),
                            testId: "match-" + String(pos) + "-select"
                          }),
                      className: "pageround__matchresult data__input row__controls"
                    }),
                tmp
              ],
              className: className + " " + (
                selected ? "selected" : ""
              ) + "}"
            });
}

function PageRound$RoundTable(props) {
  var scoreData = props.scoreData;
  var tournament = props.tournament;
  var setSelectedMatch = props.setSelectedMatch;
  var selectedMatch = props.selectedMatch;
  var matches = props.matches;
  var roundId = props.roundId;
  var __isCompact = props.isCompact;
  var isCompact = __isCompact !== undefined ? __isCompact : false;
  var match = Db$Coronate.useConfig();
  var config = match[0];
  return JsxRuntime.jsxs("table", {
              children: [
                matches.length === 0 ? null : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                        children: [
                          JsxRuntime.jsxs("caption", {
                                children: [
                                  "Round ",
                                  roundId + 1 | 0
                                ],
                                className: isCompact ? "title-30" : "title-40"
                              }),
                          JsxRuntime.jsx("thead", {
                                children: JsxRuntime.jsxs("tr", {
                                      children: [
                                        JsxRuntime.jsx("th", {
                                              children: "#",
                                              className: "pageround__row-id",
                                              scope: "col"
                                            }),
                                        JsxRuntime.jsx("th", {
                                              children: JsxRuntime.jsxs(VisuallyHidden, {
                                                    children: [
                                                      Data_Config$Coronate.aliasToStringWhite(config),
                                                      " result"
                                                    ]
                                                  }),
                                              scope: "col"
                                            }),
                                        JsxRuntime.jsx("th", {
                                              children: Data_Config$Coronate.aliasToStringWhite(config),
                                              className: "row__player",
                                              scope: "col"
                                            }),
                                        JsxRuntime.jsx("th", {
                                              children: JsxRuntime.jsxs(VisuallyHidden, {
                                                    children: [
                                                      Data_Config$Coronate.aliasToStringBlack(config),
                                                      " result"
                                                    ]
                                                  }),
                                              scope: "col"
                                            }),
                                        JsxRuntime.jsx("th", {
                                              children: Data_Config$Coronate.aliasToStringBlack(config),
                                              className: "row__player",
                                              scope: "col"
                                            }),
                                        JsxRuntime.jsx("th", {
                                              children: "Match result",
                                              className: "row__result",
                                              colSpan: 2,
                                              scope: "col"
                                            }),
                                        isCompact ? null : JsxRuntime.jsx("th", {
                                                children: JsxRuntime.jsx(VisuallyHidden, {
                                                      children: "Controls"
                                                    }),
                                                className: "row__controls",
                                                scope: "col"
                                              })
                                      ]
                                    }),
                                className: "pageround__table-head"
                              })
                        ]
                      }),
                JsxRuntime.jsx("tbody", {
                      children: Belt_Array.mapWithIndex(matches, (function (pos, m) {
                              return JsxRuntime.jsx(PageRound$MatchRow, {
                                          isCompact: isCompact,
                                          pos: pos,
                                          m: m,
                                          roundId: roundId,
                                          selectedMatch: selectedMatch,
                                          setSelectedMatch: setSelectedMatch,
                                          scoreData: scoreData,
                                          tournament: tournament,
                                          className: "pageround__tr",
                                          config: config
                                        }, Data_Id$Coronate.toString(m.id));
                            })),
                      className: "content"
                    })
              ],
              className: "pageround__table"
            });
}

var RoundTable = {
  make: PageRound$RoundTable
};

function PageRound$Round(props) {
  var tournament = props.tournament;
  var tourney = tournament.tourney;
  var roundList = tourney.roundList;
  var setTourney = tournament.setTourney;
  var playersDispatch = tournament.playersDispatch;
  var players = tournament.players;
  var roundId = props.roundId;
  var match = React.useState(function () {
        
      });
  var setSelectedMatch = match[1];
  var selectedMatch = match[0];
  var moveMatch = function (matchId, direction, round) {
    var newRound = Data_Rounds$Coronate.Round.moveMatch(round, matchId, direction);
    if (newRound === undefined) {
      return ;
    }
    var roundList$1 = Data_Rounds$Coronate.set(roundList, roundId, Caml_option.valFromOption(newRound));
    if (roundList$1 !== undefined) {
      return setTourney({
                  id: tourney.id,
                  name: tourney.name,
                  date: tourney.date,
                  playerIds: tourney.playerIds,
                  scoreAdjustments: tourney.scoreAdjustments,
                  byeQueue: tourney.byeQueue,
                  tieBreaks: tourney.tieBreaks,
                  roundList: Caml_option.valFromOption(roundList$1)
                });
    }
    
  };
  var matches = Data_Rounds$Coronate.get(tourney.roundList, roundId);
  if (matches === undefined) {
    return JsxRuntime.jsx(Pages$Coronate.NotFound.make, {});
  }
  var matches$1 = Caml_option.valFromOption(matches);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("button", {
                              children: [
                                JsxRuntime.jsx(ReactFeather.Trash2, {}),
                                " Unmatch"
                              ],
                              className: "button-micro",
                              disabled: selectedMatch === undefined,
                              onClick: (function (param) {
                                  Belt_Option.map(selectedMatch, (function (__x) {
                                          var match = Data_Rounds$Coronate.Round.getMatchById(matches$1, __x);
                                          if (match !== undefined && match.result !== "NotSet" && !Data_Match$Coronate.isBye(match)) {
                                            var reset = function (id, rating) {
                                              var player = Belt_Map.get(players, id);
                                              if (player !== undefined) {
                                                return playersDispatch({
                                                            TAG: "Set",
                                                            _0: player.id,
                                                            _1: Data_Player$Coronate.predMatchCount(Data_Player$Coronate.setRating(player, rating))
                                                          });
                                              }
                                              
                                            };
                                            reset(match.whiteId, match.whiteOrigRating);
                                            reset(match.blackId, match.blackOrigRating);
                                          }
                                          var newRound = Data_Rounds$Coronate.Round.removeMatchById(matches$1, __x);
                                          var roundList$1 = Data_Rounds$Coronate.set(roundList, roundId, newRound);
                                          if (roundList$1 !== undefined) {
                                            setTourney({
                                                  id: tourney.id,
                                                  name: tourney.name,
                                                  date: tourney.date,
                                                  playerIds: tourney.playerIds,
                                                  scoreAdjustments: tourney.scoreAdjustments,
                                                  byeQueue: tourney.byeQueue,
                                                  tieBreaks: tourney.tieBreaks,
                                                  roundList: Caml_option.valFromOption(roundList$1)
                                                });
                                          }
                                          setSelectedMatch(function (param) {
                                                
                                              });
                                        }));
                                })
                            }),
                        " ",
                        JsxRuntime.jsxs("button", {
                              children: [
                                JsxRuntime.jsx(ReactFeather.Repeat, {}),
                                " Swap colors"
                              ],
                              className: "button-micro",
                              disabled: selectedMatch === undefined,
                              onClick: (function (param) {
                                  Belt_Option.map(selectedMatch, (function (__x) {
                                          var match_ = Data_Rounds$Coronate.Round.getMatchById(matches$1, __x);
                                          if (match_ === undefined) {
                                            return ;
                                          }
                                          var newMatch = Data_Match$Coronate.swapColors(match_);
                                          Belt_Option.map(Data_Rounds$Coronate.setMatch(roundList, roundId, newMatch), (function (roundList) {
                                                  setTourney({
                                                        id: tourney.id,
                                                        name: tourney.name,
                                                        date: tourney.date,
                                                        playerIds: tourney.playerIds,
                                                        scoreAdjustments: tourney.scoreAdjustments,
                                                        byeQueue: tourney.byeQueue,
                                                        tieBreaks: tourney.tieBreaks,
                                                        roundList: roundList
                                                      });
                                                }));
                                        }));
                                })
                            }),
                        " ",
                        JsxRuntime.jsxs("button", {
                              children: [
                                JsxRuntime.jsx(ReactFeather.ArrowUp, {}),
                                " Move up"
                              ],
                              className: "button-micro",
                              disabled: selectedMatch === undefined,
                              onClick: (function (param) {
                                  Belt_Option.map(selectedMatch, (function (__x) {
                                          moveMatch(__x, -1, matches$1);
                                        }));
                                })
                            }),
                        " ",
                        JsxRuntime.jsxs("button", {
                              children: [
                                JsxRuntime.jsx(ReactFeather.ArrowDown, {}),
                                " Move down"
                              ],
                              className: "button-micro",
                              disabled: selectedMatch === undefined,
                              onClick: (function (param) {
                                  Belt_Option.map(selectedMatch, (function (__x) {
                                          moveMatch(__x, 1, matches$1);
                                        }));
                                })
                            })
                      ],
                      className: "toolbar"
                    }),
                Data_Rounds$Coronate.Round.size(matches$1) === 0 ? JsxRuntime.jsx("p", {
                        children: "No players matched yet."
                      }) : null,
                JsxRuntime.jsx(PageRound$RoundTable, {
                      roundId: roundId,
                      matches: Data_Rounds$Coronate.Round.toArray(matches$1),
                      selectedMatch: selectedMatch,
                      setSelectedMatch: setSelectedMatch,
                      tournament: tournament,
                      scoreData: Caml_option.some(props.scoreData)
                    })
              ],
              className: "content-area"
            });
}

function PageRound(props) {
  var tournament = props.tournament;
  var roundId = props.roundId;
  var match = TournamentUtils$Coronate.useRoundData(roundId, tournament);
  var unmatched = match.unmatched;
  var scoreData = match.scoreData;
  var unmatchedCount = Belt_Map.size(unmatched);
  var activePlayersCount = Belt_Map.size(tournament.activePlayers);
  var initialTab = unmatchedCount === activePlayersCount ? 1 : 0;
  var match$1 = React.useState(function () {
        return initialTab;
      });
  var setOpenTab = match$1[1];
  React.useEffect((function () {
          if (unmatchedCount === activePlayersCount) {
            setOpenTab(function (param) {
                  return 1;
                });
          }
          if (unmatchedCount === 0) {
            setOpenTab(function (param) {
                  return 0;
                });
          }
          
        }), [
        unmatchedCount,
        activePlayersCount,
        setOpenTab
      ]);
  return JsxRuntime.jsxs(Tabs.Tabs, {
              index: match$1[0],
              onChange: (function (index) {
                  setOpenTab(function (param) {
                        return index;
                      });
                }),
              children: [
                JsxRuntime.jsxs(Tabs.TabList, {
                      children: [
                        JsxRuntime.jsxs(Tabs.Tab, {
                              disabled: unmatchedCount === activePlayersCount,
                              children: [
                                JsxRuntime.jsx(ReactFeather.List, {}),
                                " Matches"
                              ]
                            }),
                        JsxRuntime.jsxs(Tabs.Tab, {
                              disabled: unmatchedCount === 0,
                              children: [
                                JsxRuntime.jsx(ReactFeather.Users, {}),
                                " Unmatched players (" + String(unmatchedCount) + ")"
                              ]
                            })
                      ]
                    }),
                JsxRuntime.jsxs(Tabs.TabPanels, {
                      children: [
                        JsxRuntime.jsx(Tabs.TabPanel, {
                              children: JsxRuntime.jsx(PageRound$Round, {
                                    roundId: roundId,
                                    tournament: tournament,
                                    scoreData: scoreData
                                  })
                            }),
                        JsxRuntime.jsx(Tabs.TabPanel, {
                              children: JsxRuntime.jsx("div", {
                                    children: unmatchedCount !== 0 ? JsxRuntime.jsx(PairPicker$Coronate.make, {
                                            roundId: roundId,
                                            tournament: tournament,
                                            scoreData: scoreData,
                                            unmatched: unmatched,
                                            unmatchedWithDummy: match.unmatchedWithDummy
                                          }) : null
                                  })
                            })
                      ]
                    })
              ]
            });
}

var make = PageRound;

export {
  RoundTable ,
  make ,
}
/* react Not a pure module */
